import { Tooltip, TooltipProps } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = Pick<TooltipProps, 'children' | 'open' | 'onClose' | 'title'>;

function ButtonTooltip({
  open,
  onClose,
  children,
  title,
}: PropsWithChildren<Props>) {
  return (
    <Tooltip
      open={open}
      onClose={onClose}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={title}
      placement="top"
      arrow
      slotProps={{
        tooltip: {
          style: {
            position: 'relative',
            background: '#777',
            borderRadius: '8px',
            color: '#fff',
            fontSize: '12px',
            lineHeight: '16px',
            padding: '6px',
            paddingRight: '24px',
          },
        },
        arrow: {
          style: {
            color: '#777',
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
}

export default ButtonTooltip;
